/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  GitSyncBranch,
  GitSyncGitHubRepository,
  GitSyncGitLabProject,
  GitSyncInstallation,
  GitSyncInstallationProvider,
  GitSyncInstallationSetup,
  GitSyncInstallationTarget,
  GitSyncRepositoryFile,
} from "./data-contracts";

/**
 * No description
 * @tags git
 * @name ListSiteGitSyncInstallations
 * @summary List the Git Sync installations for a site and its spaces
 * @request GET:/orgs/{organizationId}/sites/{siteId}/spaces/git/installations
 * @secure
 */

// @ts-ignore
export const listSiteGitSyncInstallations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: GitSyncInstallation[];
  };
  ResponseStatusCode: 200 | 400 | 401 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/spaces/git/installations",
  method: "get",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name InstallGitSyncProviderOnTarget
 * @summary Install a Git Sync provider on a target
 * @request POST:/git/installations
 * @secure
 */

// @ts-ignore
export const installGitSyncProviderOnTarget: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: {
    /** The provider of the Git Sync installation. */
    provider: GitSyncInstallationProvider;
    /** Resource targeted by a Git Sync installation. */
    target: GitSyncInstallationTarget;
  };
  RequestHeaders: {};
  ResponseBody: GitSyncInstallation;
  ResponseStatusCode: 201 | 404 | 409;
} = {
  route: "/git/installations",
  method: "post",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name GetGitSyncInstallationById
 * @summary Get a Git Sync installation
 * @request GET:/git/installations/{installationId}
 * @secure
 */

// @ts-ignore
export const getGitSyncInstallationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: GitSyncInstallation;
  ResponseStatusCode: 200 | 401 | 404;
} = {
  route: "/git/installations/{installationId}",
  method: "get",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates the installation configuration, then queues a sync operation using the new settings. A `git` priority queues an import from the selected repository and branch into GitBook; a `gitbook` priority queues an export from GitBook to the repository. Site imports require a `gitbook-docs.yaml` file at the configured project directory and return a conflict without saving or queuing the sync when the file is missing.
 * @tags git
 * @name UpdateGitSyncInstallationById
 * @summary Update a Git Sync installation configuration
 * @request PATCH:/git/installations/{installationId}
 * @secure
 */

// @ts-ignore
export const updateGitSyncInstallationById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: GitSyncInstallationSetup & {
    /** Project directories keyed by child installation ID for a site installation. */
    childInstallationProjectDirectories?: Record<string, string>;
  };
  RequestHeaders: {};
  ResponseBody: GitSyncInstallation;
  ResponseStatusCode: 200 | 401 | 404 | 409;
} = {
  route: "/git/installations/{installationId}",
  method: "patch",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name UninstallGitSyncInstallation
 * @summary Uninstall a Git Sync installation
 * @request DELETE:/git/installations/{installationId}
 * @secure
 */

// @ts-ignore
export const uninstallGitSyncInstallation: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 205 | 404;
} = {
  route: "/git/installations/{installationId}",
  method: "delete",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name ListGitHubRepositoriesForGitSyncInstallation
 * @summary List GitHub repositories available for a Git Sync installation
 * @request GET:/git/installations/{installationId}/github/repos
 * @secure
 */

// @ts-ignore
export const listGitHubRepositoriesForGitSyncInstallation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: GitSyncGitHubRepository[];
  };
  ResponseStatusCode: 200 | 401 | 404;
} = {
  route: "/git/installations/{installationId}/github/repos",
  method: "get",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name ListGitHubRepoBranchesForGitSyncInstallation
 * @summary List GitHub repository branches available for a Git Sync installation
 * @request GET:/git/installations/{installationId}/github/repos/{accountName}/{repositoryName}/branches
 * @secure
 */

// @ts-ignore
export const listGitHubRepoBranchesForGitSyncInstallation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
    accountName: string;
    repositoryName: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: GitSyncBranch[];
  };
  ResponseStatusCode: 200 | 401 | 404;
} = {
  route:
    "/git/installations/{installationId}/github/repos/{accountName}/{repositoryName}/branches",
  method: "get",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name GetGitHubRepoFileForGitSyncInstallation
 * @summary Get a file from a GitHub repository for a Git Sync installation
 * @request GET:/git/installations/{installationId}/github/repos/{accountName}/{repositoryName}/file
 * @secure
 */

// @ts-ignore
export const getGitHubRepoFileForGitSyncInstallation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
    accountName: string;
    repositoryName: string;
  };
  RequestQuery: {
    path: string;
    ref: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: GitSyncRepositoryFile;
  ResponseStatusCode: 200 | 401 | 404;
} = {
  route:
    "/git/installations/{installationId}/github/repos/{accountName}/{repositoryName}/file",
  method: "get",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name ListGitLabProjectsForGitSyncInstallation
 * @summary List GitLab projects available for a Git Sync installation
 * @request GET:/git/installations/{installationId}/gitlab/projects
 * @secure
 */

// @ts-ignore
export const listGitLabProjectsForGitSyncInstallation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: GitSyncGitLabProject[];
  };
  ResponseStatusCode: 200 | 401 | 404;
} = {
  route: "/git/installations/{installationId}/gitlab/projects",
  method: "get",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name ListGitLabProjectBranchesForGitSyncInstallation
 * @summary List GitLab project branches available for a Git Sync installation
 * @request GET:/git/installations/{installationId}/gitlab/projects/{projectId}/branches
 * @secure
 */

// @ts-ignore
export const listGitLabProjectBranchesForGitSyncInstallation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
    projectId: number;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: GitSyncBranch[];
  };
  ResponseStatusCode: 200 | 401 | 404;
} = {
  route:
    "/git/installations/{installationId}/gitlab/projects/{projectId}/branches",
  method: "get",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags git
 * @name GetGitLabProjectFileForGitSyncInstallation
 * @summary Get a file from a GitLab project for a Git Sync installation
 * @request GET:/git/installations/{installationId}/gitlab/projects/{projectId}/file
 * @secure
 */

// @ts-ignore
export const getGitLabProjectFileForGitSyncInstallation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** Identifier of the installation */
    installationId: string;
    projectId: number;
  };
  RequestQuery: {
    path: string;
    ref: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: GitSyncRepositoryFile;
  ResponseStatusCode: 200 | 401 | 404;
} = {
  route: "/git/installations/{installationId}/gitlab/projects/{projectId}/file",
  method: "get",
  streaming: false,
  tags: ["git"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
